<div class="review-entry-container d-flex flex-column gap-2 p-2 bottom-border">
  <div class="review-entry-label">{{ label }}</div>
  <div class="review-entry-value">{{ value }}</div>
</div>
